import { styled } from '@linaria/react';

export const Root = styled.div`
  display: flex;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 8px;
`;
